import {
    ArrowLeft,
    BodyMediumRegular,
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Regular,
    IconButton,
    XStack,
    YStack,
} from 'smoothie';

interface RemoveBeneficiaryConfirmationProps {
    beneficiaryName: string;
    addedByLabel: string;
    accountName: string;
    onRemoveFromAccount: () => void;
    onRemoveFromAllAccounts: () => void;
    onBack: () => void;
    isRemoving?: boolean;
}

export const RemoveBeneficiaryConfirmation = ({
    beneficiaryName,
    addedByLabel,
    accountName,
    onRemoveFromAccount,
    onRemoveFromAllAccounts,
    onBack,
    isRemoving = false,
}: RemoveBeneficiaryConfirmationProps) => {
    return (
        <YStack gap={24} paddingVertical={32}>
            <XStack width="100%" alignItems="flex-start">
                <IconButton
                    variant="secondary"
                    icon={ArrowLeft}
                    onPress={onBack}
                />
            </XStack>
            <H5Regular>
                Are you sure you want to remove this beneficiary?
            </H5Regular>
            <YStack
                borderRadius={24}
                padding={16}
                gap={4}
                backgroundColor="$gray100"
            >
                <BodyMediumRegular>{beneficiaryName}</BodyMediumRegular>
                <BodySmallRegular color="$gray1000">
                    {addedByLabel}
                </BodySmallRegular>
            </YStack>
            <YStack gap={12}>
                <Button
                    text={`Remove from ${accountName}`}
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    tone="danger"
                    disabled={isRemoving}
                    onPress={onRemoveFromAccount}
                />
                <Button
                    text="Remove from all accounts"
                    variant={ButtonVariant.TERTIARY}
                    size={ButtonSize.LARGE}
                    tone="danger"
                    disabled={isRemoving}
                    onPress={onRemoveFromAllAccounts}
                />
            </YStack>
        </YStack>
    );
};
